import React from 'react';
import './About.css';

const AboutDetail = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1 className="about-title">AKMB Hakkında</h1>
        
        <section className="about-section">
          <p>
            Atatürk Kültür Merkezi Başkanlığı bir bilim ve kültür akademisi niteliğinde olup Türk kültürü üzerinde, araştırma, yayın, tanıtım, teşvik ve ödüllendirme faaliyetlerini sürdürmekte, devletin ve toplumun öncelikleriyle yakından ilgilenmektedir.
          </p>
          <p>
            Atatürk Kültür Merkezi, kuruluşundan bu yana yüzlerce yayın yapmış, yurt içi ve yurt dışında çok sayıda konferans ve bilimsel toplantı düzenlemiş, çeşitli konularda belgeseller hazırlamıştır. Ayrıca, bugüne kadar edebiyat, sanat tarihi, tiyatro, resim, Türk müziği ve ilişkili dallarında ödüllü yarışmalar açarak Türk kültürü üzerinde araştırma yapanlara teşvik mahiyetinde ödüller vermiştir. Atatürk Kültür Merkezi Başkanlığı, desteklediği küçük projelerle yanında, Kurum içi uluslararası nitelikte, kapsamlı projeler de yürütmüştür / yürütmektedir.
          </p>
          <p>
            Ülkemizin kültürel ve doğal mirasının korunması, değerlendirilmesi, tanıtılması ve gelecek kuşaklara aktarılması konusunda, bilim ve kültür kurumlarına büyük sorumluluklar düşmektedir. Atatürk Kültür Merkezi Başkanlığı bu sorumluluğun bilinciyle diğer kurumlarla iş birliği içinde faaliyetlerini sürdürmektedir.
          </p>
        </section>

        <section className="about-section">
          <h2>Kapsam ve Amaç</h2>
          <p>
            Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi Projesi'nin temel amacı, Türkiye Cumhuriyeti dönemindeki sanatı araştırmak, belgelemek, anlamak, yaymak suretiyle sanat tarihine ve kültürel mirasa katkıda bulunmak ve bu alanda çalışan öncelikli olarak öğrencilere, bu alanda çalışan akademisyenlere, öğretmenlere ve sanata ilgi duyan herkese güvenilir, kolay ulaşılabilir bir açık kaynak sağlamaktır.
          </p>
          <p>
            Cumhuriyet Dönemi Türk Sanatı projesi, geniş bir perspektifte farklı alanları kapsamaktadır. Projenin kapsayacağı bazı alanlar şunlardır:
          </p>
          <ul>
            <li>
              Resim: Türkiye Cumhuriyeti döneminde yapılan resim çalışmaları ve sanatçılarına odaklı, Cumhuriyet dönemi ressamları, temaları, tarzları ve eserlerinin analizine yer verilecektir.
            </li>
            <li>
              Heykel: Türkiye Cumhuriyeti döneminde heykel sanatındaki gelişmeler ve önde gelen heykeltraşlar ve eserlerine yer verilecektir.
            </li>
            <li>
              Mimarlık: Türkiye Cumhuriyeti döneminde yapılan mimari çalışmalar ve mimarlar ve özellikle Cumhuriyet'in ilk yıllarında gerçekleşen ulusal mimari hareketi, modernizm ve uluslararası etkilerine yer verilecektir.
            </li>
          </ul>
          <p>
            Seramik ve El Sanatları: Türkiye Cumhuriyeti döneminde seramik, dokuma, halı, kilim gibi el sanatlarındaki gelişmelere yer verilecektir. Usta sanatçılar, geleneksel teknikler ve modern uygulamalar üzerine araştırmalar aktarılacaktır.
          </p>
          <p>
            Sanatçılar ve Eserleri: Türkiye Cumhuriyeti döneminde öne çıkan sanatçılar ve eserlerin analizi, projenin merkezi bir parçası olmalıdır. Sanatçıların yaşamı, tarzı, etkileri ve sanat eserlerinin tarihsel ve kültürel bağlamları üzerinde araştırmalara yer verilecektir.
          </p>
        </section>
 

      
      

        <section className="about-section">
          <h2 className="project-team-title">Proje Ekibi</h2>
          <img 
            src="/images/cdtst/dekoratif.png" 
            alt="Dekoratif çizgi" 
            className="decorative-line"
          />
          
          <div className="team-grid">
            <div className="team-column">
              <div className="team-content">
                <h3>Proje Yürütücüsü</h3>
                <p>Prof. Dr. Gıyasettin AYTAŞ</p>
              </div>
            </div>

            <div className="team-column">
              <div className="team-content">
                <h3>Proje Koordinatörü</h3>
                <p>Prof. Dr. Oğuz YURTTADUR</p>
              </div>
            </div>

            <div className="team-column">
              <div className="team-content">
                <h3>Proje Danışmanları</h3>
                <p>Prof. Dr. Kıymet GİRAY</p>
                <p>Prof. Dr. Burcu PELVANOĞLU</p>
              </div>
            </div>

            <div className="team-column">
              <div className="team-content">
                <h3>Proje Ekibi</h3>
                <p>Prof. Dr. Tolga BOZKURT</p>
                <p>Prof. Dr. Mehmet BÜYÜKÇANGA</p>
                <p>Doç. Dr. Mutluhan TAŞ</p>
                <p>Dr. Öğr. Üyesi Sema BİLİCİ</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutDetail; 